export default "__VITE_ASSET__c7be717b__"